import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import styles from './sidebar.module.scss';
import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export var Separator = function Separator(_ref) {
  var style = _ref.style,
      className = _ref.className,
      _ref$isAnimated = _ref.isAnimated,
      isAnimated = _ref$isAnimated === void 0 ? true : _ref$isAnimated;
  return /*#__PURE__*/_jsx("hr", {
    className: classNames(className, _defineProperty({}, styles.drawerItem, isAnimated)),
    style: style
  });
};